import {SecurityInformationRecord} from "../../../../security/info/types/SecurityInformationRecord";
import {TechnicalIndicatorsRecord} from "../../../../technical-indicators/types/TechnicalIndicatorsRecord";
import {IndustryGroup} from "../../../../instruments/industry-group/types/IndustryGroup";
import {IsoDate} from "../../../../pseudo-types/DateTypes";
import {CodeAndExchange} from "../../../../instruments/types/CodeAndExchange";
import {Exchange} from "../../../../instruments/exchange/Exchange";
import {QuoteRecord} from "../../../../quote/models/QuoteRecord";

export class CompanyStatisticsViewModel implements CodeAndExchange {

    private constructor(private readonly security: CodeAndExchange,
                        private readonly quote: QuoteRecord | null,
                        private readonly securityInfo: SecurityInformationRecord | null,
                        private readonly indicators: TechnicalIndicatorsRecord | null) {
    }

    public get code(): string {
        return this.security.code;
    }

    public get exchange(): Exchange {
        return this.security.exchange;
    }

    public get companyName(): string | null {
        if (this.securityInfo == null) {
            return null;
        } else {
            return this.securityInfo.companyName;
        }
    }

    public get industryGroup(): IndustryGroup | null {
        if (this.securityInfo == null) {
            return null;
        } else {
            return this.securityInfo.industryGroup;
        }
    }

    public get yearHigh(): number | null {
        if (this.indicators == null) {
            return null;
        } else {
            return this.indicators.yearPriceHigh;
        }
    }

    public get yearLow(): number | null {
        if (this.indicators == null) {
            return null;
        } else {
            return this.indicators.yearPriceLow;
        }
    }

    public get marketCap(): number | null {
        if (this.securityInfo == null) {
            return null;
        } else {
            return this.securityInfo.marketCap;
        }
    }

    public get earningsPerShare(): number | null {
        if (this.securityInfo == null) {
            return null;
        } else {
            return this.securityInfo.earningsPerShare / 100; // Normalised to dollars
        }
    }
    public get peRatio(): number | null {
        const eps = this.earningsPerShare;
        if (eps == null || eps === 0) {
            return null;
        }

        if (this.quote == null || this.quote.last == null) {
            return null;
        }

        const last = this.quote.last;

        return last / eps;
    }

    public get nextDividendDate(): IsoDate | null {
        return null;
    }

    public get nextDividendValue(): number | null {
        return null;
    }

    public static create(security: CodeAndExchange,
                         quote: QuoteRecord | null,
                         securityInfo: SecurityInformationRecord | null,
                         indicators: TechnicalIndicatorsRecord | null): CompanyStatisticsViewModel {
        return new CompanyStatisticsViewModel(security, quote, securityInfo, indicators);
    }
}
